import { combineReducers } from "redux";
import notificationsReducer from "./notifications";
import alertsReducer from "./alerts";
import capturesReducer from "./captures";
import devicesReducer from "./devices";
import organizationsReducer from "./organizations";
import schedulesReducer from "./schedules";
import analyticsReducer from "./analytics";
import commandReducer from "./command";
import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import { deviceApi } from "../actions/devicesInQuery";
import { trapApi } from "../actions/trapsiteInQuery";

export default combineReducers({
  notifications: notificationsReducer,
  alerts: alertsReducer,
  captures: capturesReducer,
  devices: devicesReducer,
  organizations: organizationsReducer,
  schedules: schedulesReducer,
  analytics: analyticsReducer,
  command: commandReducer,
});

export const store = configureStore({
  reducer: combineReducers({
    [deviceApi.reducerPath]: deviceApi.reducer,
    [trapApi.reducerPath]: trapApi.reducer,
    notifications: notificationsReducer,
    alerts: alertsReducer,
    captures: capturesReducer,
    devices: devicesReducer,
    organizations: organizationsReducer,
    schedules: schedulesReducer,
    analytics: analyticsReducer,
    command: commandReducer,
  }),

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(deviceApi.middleware)
      .concat(trapApi.middleware),
  devTools:
    process.env.REACT_APP_ENV !== "production"
      ? {
          trace: true,
          traceLimit: 25,
        }
      : false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
